import React from 'react';

import HoistNonReactStatics from 'hoist-non-react-statics';
import {
    ReactReduxContext,
} from 'react-redux';
import universal from 'react-universal-component';

import {
    Interstitial,
} from 'wanderu-components';

const defaultOptions = {
    ignoreBabelRename: true,
    loading: Interstitial,
    minDelay: 250,
    onLoad() { },
};

function withInterstitial(pagePromise, options = {}) {
    const Ucmp = universal(pagePromise, {
        ...defaultOptions,
        ...options,
        onLoad(module, meta, props, context) {
            if (props.__reduxContext && options.onLoad) {
                options.onLoad(module, meta, props, props.__reduxContext);
            }
        },
    });

    return HoistNonReactStatics((props) => {
        return (
            <ReactReduxContext.Consumer>
                {(reduxContext) => <Ucmp {...props} __reduxContext={reduxContext} />}
            </ReactReduxContext.Consumer>
        );
    }, Ucmp);
}
export default withInterstitial;
